import { XCircleIcon } from '@heroicons/react/solid';
import React from 'react';

const PlantFormButtons = (props) => {
  return (
    <div className="flex justify-end sm:flex-row flex-col w-full gap-2">
      <button
        type="button"
        disabled={props.isUploading}
        onClick={props.handleOpenForm}
        className="text-gray-500 w-10 ml-auto border-2 border-gray-300 rounded-full py-2 px-2 focus:outline-none hover:text-gray-500 hover:border-gray-500 disabled:hover:text-gray-500 disabled:hover:border-gray-300 disabled:cursor-not-allowed text-lg"
      >
        <XCircleIcon className="w-5 h-5" />
      </button>
      <button
        type="submit"
        disabled={props.isUploading}
        className="text-white bg-accent-500 border-0 py-2 px-8 focus:outline-none hover:bg-accent-600  disabled:bg-gray-700 disabled:hover:bg-gray-700 rounded text-lg disabled:cursor-not-allowed"
      >
        {props.editArea || props.editPlant ? 'Update' : 'Add'}
      </button>
    </div>
  );
};

export default PlantFormButtons;
